import formatValue from '../../../../shared/utils/formatValue';
import { DurationEditorSpec } from '../../../models/Editor';
import { UiProfileProperty } from '../../../models/UiProfile';
import { DeviceEditablePropertyValue, SectionItemEditor } from '../buildEditor';

export function buildDurationEditor(
    uiProperty: UiProfileProperty,
    value: DeviceEditablePropertyValue,
): SectionItemEditor {
    const editor = uiProperty.editor as DurationEditorSpec;

    return {
        type: 'duration',
        value,
        inputHelper: {
            key: 'WARNING_TIMER',
            arguments: {
                max: formatValue(editor.max, uiProperty.formatter),
            },
        },
        config: {
            precision: editor.precision,
            max: editor.max,
        },
    };
}
